import { useEffect, useRef, useState } from 'react';

// value: nombre à animer. decimals: nombre de chiffres après la virgule.
// suffix : chaîne à afficher après le nombre (€, %, etc.).
const STATS = [
  { value: 54491, decimals: 0, suffix: '€', label: 'Chiffre d\'affaires généré' },
  { value: 203, decimals: 0, suffix: '', label: 'Élèves accompagnés' },
  { value: 173, decimals: 0, suffix: '', label: 'Élèves ont dépassé 5\u00A0000€/mois' },
  { value: 85.2, decimals: 1, suffix: '%', label: 'D\'élèves qui atteignent 5\u00A0000€/mois' },
];

const formatNumber = (n, decimals) =>
  new Intl.NumberFormat('fr-FR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(n);

const AnimatedNumber = ({ value, decimals, suffix }) => {
  const [display, setDisplay] = useState(0);
  const ref = useRef(null);
  const startedRef = useRef(false);

  useEffect(() => {
    if (!ref.current) return;
    const reducedMotion =
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const el = ref.current;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !startedRef.current) {
            startedRef.current = true;
            if (reducedMotion) {
              setDisplay(value);
              io.disconnect();
              return;
            }
            const duration = 1200;
            const start = performance.now();
            const factor = Math.pow(10, decimals);
            const step = (now) => {
              const t = Math.min(1, (now - start) / duration);
              const eased = 1 - Math.pow(1 - t, 3);
              const current = Math.round(value * eased * factor) / factor;
              setDisplay(current);
              if (t < 1) requestAnimationFrame(step);
              else setDisplay(value);
            };
            requestAnimationFrame(step);
            io.disconnect();
          }
        });
      },
      { threshold: 0.3 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [value, decimals]);

  return (
    <span
      ref={ref}
      className="font-serif tabular-nums"
      style={{ color: '#E8D9AA', fontSize: '38px', lineHeight: 1, fontWeight: 500 }}
    >
      {formatNumber(display, decimals)}
      {suffix}
    </span>
  );
};

export const StatsBar = () => {
  return (
    <section data-testid="stats-bar" className="px-5 md:px-8 py-7 md:py-10">
      <div className="max-w-5xl mx-auto">
        <div className="rule" />
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-8 md:gap-y-0 gap-x-4 md:gap-x-6 py-8">
          {STATS.map((s) => (
            <div key={s.label} className="flex flex-col items-center text-center gap-2 md:gap-3">
              <AnimatedNumber value={s.value} decimals={s.decimals} suffix={s.suffix} />
              <span
                className="text-[#F5EFE3]/65 leading-snug"
                style={{
                  fontSize: '15px',
                  letterSpacing: '0.14em',
                  textTransform: 'uppercase',
                  fontWeight: 500,
                }}
              >
                {s.label}
              </span>
            </div>
          ))}
        </div>
        <div className="rule" />
      </div>
    </section>
  );
};

export default StatsBar;
